import { useEffect, useState } from "react"
import { Backend } from "../../services/Backend";
import StripePricingTable from "../../components/StripePricingTable";
import { Button } from "@mui/material";

export default function SubscriptionSettingPage(){
    const [currentPlan, setCurrentPlan] = useState("Free trial");
    
    useEffect(() => {
        Backend.get('user/me/subscription')
            .then(res=> {
                setCurrentPlan(res.name);
            });
    }, []);

    const openCustomerPortal = () => {

        Backend.get('stripe/portal')
        .then(res => {
            window.open(res.url, "_blank");
        });
    }

    return <div>
        <p className="text-2xl">Current plan</p>
        <p className="my-2 font-semibold">{currentPlan}</p>

        <div>
            <Button variant="contained" onClick={openCustomerPortal}>Open customer portal</Button>
        </div>
    </div>
}